import { REHYDRATE } from 'redux-persist';
import update from 'immutability-helper';
import { keysLS, getLSItem } from 'util/localStorageProvider';
import {
  updatedObject,
  addNestedFields,
  removeNestedFields,
  ANY_FIELD_UPDATE,
  ANY_FIELD_ADD,
  ANY_FIELD_REMOVE,
} from 'actions/formActions';
import {
  INSPECTION_LIST_FETCH_BEGIN,
  INSPECTION_LIST_FETCH_SUCCESS,
  INSPECTION_LIST_RESET,
  INSPECTION_LIST_FETCH_FAIL,
  INSPECTION_JOBS_FETCH_WITH_FILTERS_BEGIN,
  INSPECTION_JOBS_FETCH_WITH_FILTERS_SUCCESS,
  INSPECTION_JOBS_FETCH_WITH_FILTERS_FAIL,
  INSPECTION_JOB_ANALYTICS_CHART_GET_BEGIN,
  INSPECTION_JOB_ANALYTICS_CHART_GET_SUCCESS,
  INSPECTION_JOB_ANALYTICS_CHART_GET_FAIL,
  INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_BEGIN,
  INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_SUCCESS,
  INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_FAIL,
  INSPECTION_FILTERS_APPLY,
  INSPECTION_FILTERS_RESET,
  InspectionTypes,
  INSPECTION_JOB_SET_VALIDATE_DATA,
} from './types';

import INITIAL_STATE from './state';

const getStoredState = (state) => {
  let params = {};
  if (getLSItem(keysLS.inspectionListTableParams)) {
    params = JSON.parse(getLSItem(keysLS.inspectionListTableParams));
  }

  const { currTab = null } = params;

  if (getLSItem(keysLS.inspectionListFilterParams)) {
    params = JSON.parse(getLSItem(keysLS.inspectionListFilterParams));
  }

  const { searchKeyword = null, filters = null } = params;

  return {
    ...state,
    data: {
      ...state.data,
      currTab: currTab || state.data.currTab,
      searchKeyword: searchKeyword || state.data.searchKeyword,
      filters: filters || state.data.filters,
    },
  };
};

export default function inspectionListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case ANY_FIELD_UPDATE:
      if (action.storeName !== 'inspectionList') return state;

      return {
        ...state,
        data: updatedObject(state.data, action.accessPath, action.newVal),
      };

    case ANY_FIELD_ADD:
      if (action.storeName !== 'inspectionList') return state;

      return {
        ...state,
        data: addNestedFields(state.data, action.accessPath, action.newObj),
      };

    case ANY_FIELD_REMOVE:
      if (action.storeName !== 'inspectionList') return state;

      return {
        ...state,
        data: removeNestedFields(state.data, action.accessPath),
      };

    case INSPECTION_FILTERS_APPLY:
      return update(state, { data: { filters: { $set: action.filters } } });

    // INPSECTION LIST FETCH

    case INSPECTION_LIST_FETCH_BEGIN:
      return { ...state, status: 'fetching' };

    case INSPECTION_LIST_FETCH_SUCCESS:
      return update(state, {
        data: { jobs: { $set: action.data } },
        status: { $set: 'success' },
      });

    case INSPECTION_LIST_FETCH_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    // INSPECTION ANALYTICS CHART FETCH

    case INSPECTION_JOB_ANALYTICS_CHART_GET_BEGIN:
      return { ...state, status: 'fetching' };

    case INSPECTION_JOB_ANALYTICS_CHART_GET_SUCCESS:
      return update(state, {
        data: { chartData: { $set: action.data } },
        status: { $set: 'success' },
      });

    case INSPECTION_JOB_ANALYTICS_CHART_GET_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    // INSPECTION ANALYTICS CHART FETCH WITH FILED

    case INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_BEGIN:
      return { ...state, status: 'fetching' };

    case INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_SUCCESS:
      return update(state, {
        data: { chartData: { $set: action.data } },
        status: { $set: 'success' },
      });

    case INSPECTION_JOB_ANALYTICS_CHART_GET_WITH_FILTER_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    // INSPECTION LIST FETCH WITH FIELDS

    case INSPECTION_JOBS_FETCH_WITH_FILTERS_BEGIN:
      return { ...state, status: 'applying' };

    case INSPECTION_JOBS_FETCH_WITH_FILTERS_SUCCESS:
      return update(state, {
        data: { jobs: { $set: action.data } },
        status: { $set: 'success' },
      });

    case INSPECTION_JOBS_FETCH_WITH_FILTERS_FAIL:
      return { ...state, status: 'failed', reason: action.reason };

    case INSPECTION_FILTERS_RESET:
      return update(state, {
        data: {
          searchKeyword: { $set: INITIAL_STATE.data.searchKeyword },
          filters: { $set: INITIAL_STATE.data.filters },
        },
      });

    case INSPECTION_LIST_RESET:
      return INITIAL_STATE;

    //-------------------------------------------------
    // GET_INSPECTION_SERVICE_PROVIDER
    case InspectionTypes.GET_INSPECTION_SERVICE_PROVIDER.LOADING:
      return {
        ...state,
        serviceProviders: {
          ...state.serviceProvider,
          loading: true,
          error: null,
        },
      };
    case InspectionTypes.GET_INSPECTION_SERVICE_PROVIDER.SUCCESS:
      return {
        ...state,
        serviceProviders: {
          loading: false,
          data: action.payload,
          error: null,
        },
      };
    case InspectionTypes.GET_INSPECTION_SERVICE_PROVIDER.ERROR:
      return {
        ...state,
        serviceProviders: {
          loading: false,
          data: [],
          error: action.payload,
        },
      };
    case InspectionTypes.UPDATE_SEARCH_DATA:
      return {
        ...state,
        searchData: action.payload,
      };

    default:
      return getStoredState(state);
  }
}
